(() => {
  const init = () => {
    document.querySelectorAll('[data-ttw-reveal]').forEach((element) => {
      if (element.dataset.ttwRevealBound) return;
      element.dataset.ttwRevealBound = 'true';
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      }), { threshold: 0.14 });
      observer.observe(element);
    });

    document.querySelectorAll('[data-ttw-carousel]').forEach((root) => {
      if (root.dataset.ttwCarouselBound) return;
      root.dataset.ttwCarouselBound = 'true';
      const track = root.querySelector('[data-ttw-track]');
      if (!track) return;
      const cards = [...track.children];
      const prev = root.querySelector('[data-ttw-prev]');
      const next = root.querySelector('[data-ttw-next]');
      if (cards.length < 2) return;
      let index = 0;
      let timer;
      const visible = () => innerWidth <= 640 ? 1 : innerWidth <= 820 ? 2 : 4;
      const max = () => Math.max(0, cards.length - visible());
      const render = () => {
        const gap = parseFloat(getComputedStyle(track).gap) || 0;
        const width = cards[0].getBoundingClientRect().width + gap;
        track.style.transform = `translate3d(${-index * width}px,0,0)`;
        cards.forEach((card, cardIndex) => card.classList.toggle('is-active', cardIndex === index));
      };
      const move = (step) => {
        index += step;
        if (index > max()) index = 0;
        if (index < 0) index = max();
        render();
      };
      const start = () => {
        clearInterval(timer);
        if (root.dataset.autoplay === 'true') timer = setInterval(() => move(1), Math.max(3000, Number(root.dataset.speed || 5) * 1000));
      };
      prev?.addEventListener('click', () => { move(-1); start(); });
      next?.addEventListener('click', () => { move(1); start(); });
      let startX = 0;
      root.addEventListener('pointerdown', (event) => { startX = event.clientX; });
      root.addEventListener('pointerup', (event) => {
        const delta = event.clientX - startX;
        if (Math.abs(delta) > 45) { move(delta < 0 ? 1 : -1); start(); }
      });
      addEventListener('resize', () => { index = Math.min(index, max()); render(); }, { passive: true });
      render();
      start();
    });

    document.querySelectorAll('[data-ttw-video]').forEach((root) => {
      if (root.dataset.ttwVideoBound) return;
      root.dataset.ttwVideoBound = 'true';
      const videos = [...root.querySelectorAll('video')];
      if (videos.length < 2) return;
      let current = 0;
      setInterval(() => {
        videos[current].classList.remove('is-active');
        current = (current + 1) % videos.length;
        videos[current].classList.add('is-active');
        videos[current].play().catch(() => {});
      }, Math.max(5000, Number(root.dataset.speed || 7) * 1000));
    });

    document.querySelectorAll('[data-ttw-location-open]').forEach((button) => {
      if (button.dataset.ttwLocationBound) return;
      button.dataset.ttwLocationBound = 'true';
      button.addEventListener('click', () => {
        const dialog = document.getElementById(button.dataset.ttwLocationOpen);
        if (dialog && !dialog.open) dialog.showModal();
      });
    });
    document.querySelectorAll('[data-ttw-location-close]').forEach((button) => {
      if (button.dataset.ttwLocationBound) return;
      button.dataset.ttwLocationBound = 'true';
      button.addEventListener('click', () => button.closest('dialog')?.close());
    });
    document.querySelectorAll('.ttw-location-modal').forEach((dialog) => {
      if (dialog.dataset.ttwBackdropBound) return;
      dialog.dataset.ttwBackdropBound = 'true';
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
    });
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();
